import axios from '@/api/axios'

const changeRemovalRequests = (feedback) => {
  return axios.post('/removal-application', feedback)
}

const changeRemovalRequestsStatus = (feedbackId, data) => {
  return axios.put(`/removal-application/${feedbackId}`, data)
}

const getRemovalRequestsList = (params) => {
  return axios.get('/removal-application', {params})
}

const getRemovalRequestsInfo = (id) => {
  return axios.get(`/removal-application/${id}`)
}

export default {
  getRemovalRequestsList,
  getRemovalRequestsInfo,
  changeRemovalRequests,
  changeRemovalRequestsStatus,
}
